export const DASHBOARD_CONFIRM_ACTIONS = {
  DELETE_WIDGET: 'DELETE_WIDGET',
  DELETE_ROW: 'DELETE_ROW',
};

export const EMPTY_DASHBOARD_CONFIRM_MODAL = {
  isOpen: false,
  message: '',
  actionType: null,
  payload: null,
};
